import { render, staticRenderFns } from "./delConfirm.vue?vue&type=template&id=2c982390&scoped=true"
import script from "./delConfirm.vue?vue&type=script&lang=js"
export * from "./delConfirm.vue?vue&type=script&lang=js"
import style0 from "./delConfirm.vue?vue&type=style&index=0&id=2c982390&prod&lang=scss"
import style1 from "./delConfirm.vue?vue&type=style&index=1&id=2c982390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c982390",
  null
  
)

export default component.exports